export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"locale":"th","fallbackLocale":"th","messages":{"en":{"home":{"title":"Welcome"},"navbar":{"sign_up":"Sign Up","all_products":"All Products","product_samples":"Product samples","faq":"FAQ","articles":"Articles","sign_in":"Sign In","my_design":"Free Design"},"products":{"title":"All Products"},"sample_products":{"title":"All Sample Products"},"loading":"Loading..."},"th":{"home":{"title":"ยินดีต้อนรับ"},"navbar":{"sign_up":"สมัครสมาชิก","all_products":"บรรจุภัณฑ์ทั้งหมด","product_groups":"บรรจุภัณฑ์ตามชนิดสินค้า","product_samples":"ผลงานที่ผ่านมา","my_design":"ออกแบบฟรีบนเว็บ","faq":"คำถามที่พบบ่อย","articles":"บทความ/โปรโมชั่น","sign_in":"เข้าสู่ระบบ","box_template":"ฟรีเทมเพลตกล่อง"},"products":{"title":"บรรจุภัณฑ์ทั้งหมด"},"sample_products":{"title":"ผลงานที่ผ่านมา"},"loading":"กำลังดำเนินการ..."}}},
  vueI18nLoader: false,
  locales: ["th","en"],
  defaultLocale: "th",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"th"},{"code":"en"}],
  localeCodes: ["th","en"],
  additionalMessages: [],
}

export const localeMessages = {}
